import React, {Component} from 'react';
import {connect} from "react-redux";
import CircularProgress from "@material-ui/core/es/CircularProgress";
import Backdrop from "@material-ui/core/es/Backdrop";

class LoadingBackDrop extends Component {

    render() {
        const {app} = this.props;
        if (app.loadingBackDrop) {
            return (
                <div>
                    <Backdrop open={true} style={styles.backDrop}/>
                    <CircularProgress size={100} style={styles.loadingCricle}/>
                </div>
            )
        }
        return <div/>
    }
}

const styles = {
    loadingCricle: {
        zIndex: '9999999999',
        position: 'absolute',
        top: '50%',
        left: '50%',
        margin: '-50px 0 0 -50px',
        color: 'white'
    },
    backDrop: {
        zIndex: 99999
    }
};

const mapStateToProps = ({app}) => ({app});

export default connect(mapStateToProps, {})(LoadingBackDrop);



// WEBPACK FOOTER //
// ./src/components/LoadingBackDrop.js